import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {DomainAggregateWorkspaceCapabilityAccessOperation} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/domainAggregateWorkspaceCapability/domain/DomainAggregateWorkspaceCapabilityAccessOperation";
import type {WorkspaceCapability} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapability";
import {WorkspaceCapabilityStatus} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapability";
import type {WorkspaceCapabilityAccessMatrix} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityAccessMatrix";
import {WorkspaceCapabilityType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityType";

export function hasDomainAggregateReadAccess({
    workspaceCapabilities,
    workspaceCapabilityAccessMatrix,
}: {
    workspaceCapabilities: Array<WorkspaceCapability<WorkspaceCapabilityType>>;
    workspaceCapabilityAccessMatrix: WorkspaceCapabilityAccessMatrix | undefined;
}): boolean {
    const capabilityEnabled = workspaceCapabilities.some(
        (capability) =>
            capability.type === WorkspaceCapabilityType.domainAggregate
            && capability.status === WorkspaceCapabilityStatus.enabled,
    );
    if (capabilityEnabled !== true) {
        return false;
    }
    return workspaceCapabilityAccessMatrix?.[WorkspaceCapabilityType.domainAggregate as Uuid]?.[
        DomainAggregateWorkspaceCapabilityAccessOperation.read as Uuid
    ] === true;
}
